import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';

export const Layout = styled.div`
    ${mediaQuery.minimum('normal')} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: ${spaces['2bu']};
    }
`;

export const MainContent = styled.div`
    ${mediaQuery.minimum('normal')} {
        order: 1;
        flex-grow: 1;
    }
`;

export const SideContent = styled.div<{ offset?: string }>`
    ${mediaQuery.between('small', 'medium')} {
        margin-top: ${spaces['3bu']};
    }

    ${mediaQuery.minimum('normal')} {
        order: 2;
        min-width: 320px;
        max-width: 320px;
        height: fit-content;
        top: ${spaces['2bu']};
        position: sticky;
        margin-top: ${({ offset }) => (offset ? offset : 0)};
    }
`;
